<template>
  <DialogCard>
    <template #title>
      Imaging Centers
    </template>
    <template #text>
      <p>
        Let us augment your diagnoses with the latest in computational solutions.
      </p>
      <ul>
        <li>
          We help imaging centers differentiate their services and increase their referrals.
        </li>
        <li>
          Our automated analyses help you save time and increase accuracy. We can provide you with
          customized reports that quantify what is hard to see with the human eye.
        </li>
        <li>
          We make it easy to compare medical images over time and integrate our services with your
          existing PACS system.
        </li>
        <li>
          Discover what neuralike can do for you. <a>Schedule a demo today.</a>
        </li>
      </ul>
    </template>
  </DialogCard>
</template>

<script>
import DialogCard from '@/layout/BottomDrawer/DialogCard.vue';

export default {
  name: 'NeuralikeImagingCentersDialog',
  components: {
    DialogCard,
  },
};
</script>
